/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AccessTokenProviderDto } from './AccessTokenProviderDto';
import type { DatasourceProviderDto } from './DatasourceProviderDto';
import type { GenericProviderDto } from './GenericProviderDto';
import type { GroupIdentifierDto } from './GroupIdentifierDto';
import type { RuleRunDto } from './RuleRunDto';
import type { UserProviderDto } from './UserProviderDto';

export type DatapointQualificationDto = {
    comment?: string;
    createdBy?: string;
    createdDate?: number;
    date: number;
    group?: GroupIdentifierDto;
    id: string;
    lastModifiedDate?: number;
    modifiedBy?: string;
    provider?: (AccessTokenProviderDto | DatasourceProviderDto | GenericProviderDto | UserProviderDto);
    qualification: DatapointQualificationDto.qualification;
    ruleRunDto?: RuleRunDto;
};

export namespace DatapointQualificationDto {

    export enum qualification {
        NO_QUALIFICATION = 'NO_QUALIFICATION',
        FALSE_NEGATIVE = 'FALSE_NEGATIVE',
        FALSE_POSITIVE = 'FALSE_POSITIVE',
        FIXED = 'FIXED',
        NO_ACTION_NEEDED = 'NO_ACTION_NEEDED',
        REVIEWED = 'REVIEWED',
    }


}
